<template lang="html">
  <div class="">
    <br>
    <h2 :style="{marginLeft: (size || 160)+'px', textAlign: 'left'}">Tipologia Tessera</h2><br><br>
    <Form ref="form" v-if="form" :label-width="size || 160" @submit.native="post(form)" :model="form" :show-message="false">
      <Row>
        <Col span="24"><FormItem label="Nome tessera" :rules="req" prop="label">
          <Input v-model="form.label"/>
        </FormItem></Col>
        <Col span="24"><FormItem label="Quota associativa" prop="price" :rules="req">
          <NumInput v-model="form.price" :disabled="!!form.id"/>
          <i>Cambiare il prezzo di una tessera esistente non è consentito, ma puoi crearne una nuova e usare quella.</i>
        </FormItem></Col>
        <Col span="24" style="text-align:center">
          <FormItem class="">
            <Button type="error" @click="$emit('close')">
              Annulla
            </Button>
            &nbsp;
            <Button type="primary" @click="post(form)">
              Salva
            </Button>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  props: [
    'edit',
    'size',
  ],

  data () {
    return {
      form: this.edit ? this._.clone(this.edit) : {},
    }
  },

  methods: {
    post(data) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          data.company_id = this.$store.company.id
          var is_new = !data.id
          this.$http.post('associate-cards', data).then(res => {
            this.$emit('close')
            this.$root.$emit('associate-cards')
            this.$Message.success('Salvato')
          })
        } else {
          this.$Message.error('Controllare gli errori');
        }
      })
    },
  }
}
</script>

<style lang="css">
</style>
